import React, { useEffect } from "react";
import { Tab, Container, Grid } from "semantic-ui-react";
import { connect } from "react-redux";
import { useFirestoreConnect } from "react-redux-firebase";
import GalleryItemVideo from "../components/Gallery/GalleryItemVideo/GalleryItemVideo";
import GalleryImageItem from "../components/Gallery/GalleryImageItem/GalleryImageItem";
import { getVideos } from "../redux/actions/videos";

const panes = [
  {
    menuItem: "Imágenes",
    render: () => {
      return (
        <div className="text-center">
          <Tab.Pane loading={false}>
            <GalleryImageItem />
          </Tab.Pane>
        </div>
      );
    },
  },
  {
    menuItem: "Videos",
    render: (props) => (
      <Tab.Pane loading={false}>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <Grid.Row centered>
            {props.videos.map((video) => (
              <GalleryItemVideo video={video} key={video.id} />
            ))}
          </Grid.Row>
        </Grid>
      </Tab.Pane>
    ),
  },
];

const Gallery = (props) => {
  const { getVideos, galleries, videos } = props;

  useFirestoreConnect(() => {
    return [{ collection: "galleries" }];
  });

  useEffect(() => {
    getVideos();
  }, [getVideos]);

  return (
    <div className="container-Sections">
      <Container fluid className="locationDisplayNavbar">
        <Tab
          panes={panes}
          galleries={galleries}
          videos={videos}
          className="mt-5"
        />
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    galleries: state.firestore.ordered.galleries,
    videos: state.videos.videos,
  };
};

export default connect(mapStateToProps, { getVideos })(Gallery);
